export default __webpack_public_path__ + "48980f9d68775fe1b11ecd9594481c66.png";